import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import * as S from './styled';

export const WizardStepper = ({ steps, activeStep, width = '230px', testId }) => (
  <S.Container $width={width} data-testid={testId}>
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map(({ key, label, optionalLabel, testId: stepTestId }) => (
        <Step key={key}>
          <StepLabel
            optional={optionalLabel && <S.OptionalStep>{optionalLabel}</S.OptionalStep>}
            data-testid={stepTestId}>
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  </S.Container>
);

WizardStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      optionalLabel: PropTypes.string,
      testId: PropTypes.string
    })
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
  width: PropTypes.string,
  testId: PropTypes.string
};
